import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import QuillToolbar from './QuillToolbar';

//Quill
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';

import { formats, modulesQuill } from '../../../../constants/admin/blog_constants';
import BlockFormat from './BlockFormat';

const QuillEditDialog = ({ open, setOpen, row, setRow }) => {
    const { blog_data: { blockInEdition } } = useSelector(state => state.blog);
    // bloque a editar
    const { row_index, ...block_item } = blockInEdition;
    const { item, type, xs: _xs, md: _md, id } = block_item;
    
    // texto de bloque
    const [text, setText] = useState('');
    // longitud de columnas según el dispositivo
    const [xs, setXS] = useState(12);
    const [md, setMD] = useState(6);
    // fila en donde se insertará el bloque
    const [selectedRow, setSelectedRow] = useState(0);

    useEffect(() => {
        setText(item);
        setXS(_xs);
        setMD(_md);
        setSelectedRow(row_index);
    }, [open, blockInEdition]);

    // campo Quill Editor
    const handleChange = (html) => {
        setText(html);
    };

    // cerrar Dialog
    const handleClose = () => {
        setOpen(false);
    };

    // actualizar bloque de Quill
    const updateBlock = () => {
        setRow(e => e.map((row, index) => {
            // se cambiará fila de lugar
            if (row_index !== selectedRow) {
                if (index === row_index) // fila actual, se retirá bloque
                    return {
                        ...row,
                        col: row.col.filter(u => u.id !== id)
                    };

                if (index === selectedRow) // nueva fila, se inserta bloque
                    return {
                        ...row,
                        col: [...row.col, { ...block_item, item: text, xs, md }]
                    };

                return row; // las demás filas sin cambios
            }

            if (index === selectedRow) { // no se movió de fila
                return {
                    ...row, // se actualiza bloque
                    col: row.col.map(u =>
                        u.id === id ? { ...u, item: text, xs, md } : u
                    )
                };
            }

            return row;
        }));
        handleClose();
    };

    return (
        <Dialog
            open={ open }
            onClose={ handleClose }
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { width: '100%' } }}>
            <DialogTitle id="alert-dialog-title">
                Contenido de bloque
            </DialogTitle>
            <DialogContent>
                {
                    type === 'txt' &&
                        <Box sx={{ my: 3 }}>
                            <QuillToolbar />
                            <ReactQuill
                                value={text}
                                onChange={handleChange}
                                modules={modulesQuill}
                                formats={formats}
                            />
                        </Box>
                }
                
                <BlockFormat
                    xs={xs}
                    setXS={setXS}
                    md={md}
                    setMD={setMD}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    rowLength={row.length}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={ handleClose }>Cancelar</Button>
                <Button onClick={ updateBlock } autoFocus>
                    Actualizar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default QuillEditDialog;